{
  "cashier": "Kasa",
  "depositTab": "Yatırım",
  "withdrawTab": "Çekim",
  "historyTab": "Geçmiş",
  "secureNote": "Güvenli ve şifreli",
  "selectMethod": "Ödeme yöntemi seçin",
  "amount": "Tutar",
  "amountPlaceholder": "Tutar girin",
  "quickAmounts": "Hızlı tutarlar",
  "continue": "Devam",
  "depositNow": "Şimdi yatır",
  "withdrawNow": "Çekim talep et",
  "methodDisabled": "Bu yöntem henüz aktif değil",
  "methodsPending": "Ödeme bilgileri henüz yönetici tarafından yapılandırılmadı",
  "receiptRequired": "Dekont yükleme zorunlu — dekont ödeme kanıtı değildir",
  "adminVerification": "Bakiye yalnızca bağımsız yönetici doğrulamasından sonra artar",
  "noCryptoNetworks": "Kripto ağı yapılandırılmadı",
  "noAddress": "Henüz yatırım adresi atanmadı",
  "cardToCard": "Karttan karta",
  "cardToCardDesc": "Banka kartı transferi",
  "m10": "M10",
  "m10Desc": "M10 transferi",
  "terminal": "Terminal",
  "terminalDesc": "Terminal ödemesi",
  "crypto": "Kripto",
  "cryptoDesc": "Kripto yatırımı",
  "bankCardWithdraw": "Banka kartı",
  "m10Withdraw": "M10",
  "cryptoWithdraw": "Kripto",
  "minMax": "Min {{min}} — Maks {{max}}",
  "trustInstant": "Yapılandırıldığında hızlı işlem",
  "trustSecure": "Güvenli işlemler",
  "trustMethods": "Karttan karta, M10, Terminal, Kripto",
  "historyEmpty": "İşlem yok",
  "historyAuth": "Geçmişi görmek için giriş yapın",
  "balanceTitle": "Bakiye",
  "openCashier": "Kasa",
  "topUp": "Bakiye yükle",
  "bonusAccount": "Bonus hesabı",
  "reservedFunds": "Rezerve",
  "copyId": "ID'mi kopyala",
  "loginRequired": "Devam etmek için giriş yapın",
  "region": "Ödeme bölgesi",
  "instructionsSoon": "Talimatlar, ödeme bilgisi atandıktan sonra burada görünür",
  "uploadReceipt": "Dekont yükle",
  "uploadDisabled": "Yatırım talebi oluşmadan dekont kabul edilmez",
  "depositCreated": "Yatırım talebi oluşturuldu",
  "receiptUploaded": "✅ Dekont yüklendi. Ödeme talebiniz kaydedildi. Lütfen bekleyin.",
  "withdrawReserved": "Çekim rezerve edildi",
  "destination": "Alıcı bilgileri",
  "destinationRequired": "Alıcı bilgilerini girin",
  "noCvv": "CVV ve PIN asla istenmez veya kabul edilmez",
  "status": "Durum",
  "copy": "Kopyala",
  "bankPayment": "Banka ödemesi",
  "currentBalance": "Güncel bakiye: {{amount}}",
  "copied": "Kopyalandı",
  "selectCoin": "Coin",
  "selectNetwork": "Ağ",
  "timeRemaining": "Kalan süre",
  "depositExpired": "Bu yatırım talebinin süresi doldu. Yeni bir tane oluşturun.",
  "cancelDeposit": "Talebi iptal et",
  "qrLabel": "Yatırım adresi QR",
  "copyAddress": "Adres",
  "cardHolder": "Kart sahibi (isteğe bağlı)",
  "sendExactAmount": "Gösterilen tutarı tam gönderin. Yanlış ağ veya tutar yüklenmez.",
  "noPairsConfigured": "Henüz coin/ağ çifti yapılandırılmadı",
  "depositCancelled": "Yatırım talebi iptal edildi",
  "usdRate": "1 USD = {{rate}} AZN",
  "minUsd": "Min ${{usd}}",
  "saveQr": "QR kodunu kaydet",
  "networkWarning": "Yalnızca {{network}} ağında gönderin. Yanlış ağ kalıcı fon kaybına yol açabilir.",
  "filter_all": "Tümü",
  "filter_deposit": "Yatırım",
  "filter_withdrawal": "Çekim",
  "field_card_number": "Kart numarası",
  "field_card_holder": "Kart sahibi",
  "field_bank_name": "Banka",
  "field_m10_account": "M10 hesabı",
  "field_account_holder": "Hesap sahibi",
  "field_terminal_code": "Terminal kodu",
  "field_address": "Adres",
  "field_asset": "Coin",
  "field_network": "Ağ",
  "field_memo": "Memo",
  "field_phone": "Telefon",
  "field_iban": "IBAN",
  "field_name": "Ad",
  "methodSelected_card_to_card": "Karttan karta ödeme seçildi",
  "methodSelected_m10": "M10 ödemesi seçildi",
  "methodSelected_terminal": "Terminal ödemesi seçildi",
  "methodSelected_crypto": "Kriptopara seçildi",
  "cryptoUnavailable": "Kriptopara yatırımı hazır değil",
  "cryptoUnavailableHint": "Doğrulanmış alıcı adresi/ağı yapılandırılmadı. Fon göndermeyin — sahte cüzdan asla gösterilmez.",
  "quotePreview": "Kur",
  "expectedCredit": "Beklenen AZN yüklemesi",
  "estimatedCrypto": "Tahmini kripto tutarı",
  "adminRateNote": "Bu kur yönetici tarafından belirlenir. Canlı piyasa fiyatı değildir.",
  "enterAmountFirst": "Önce tutarı girin, ardından coin ve ağı seçin.",
  "status_waiting_for_payment": "Ödeme bekleniyor",
  "status_detected": "Transfer algılandı",
  "status_awaiting_confirmations": "Onaylar bekleniyor",
  "status_pending_review": "İnceleme bekleniyor",
  "status_confirmed": "Onaylandı",
  "status_expired": "Süresi doldu",
  "status_ambiguous": "Manuel inceleme gerekli",
  "status_error": "Hata / desteklenmiyor",
  "status_cancelled": "İptal edildi",
  "status_rejected": "Reddedildi",
  "status_approved": "Onaylandı",
  "expiredLateNote": "Süresi dolduktan sonra da zincir üstü geç transfer gelebilir. Otomatik yüklenmez ve izlenebilir inceleme gerektirir.",
  "enlargeQr": "QR'ı büyüt",
  "closeQr": "Kapat",
  "confirmationTimeNote": "10 dakikalık sayaç talep bekleme penceresidir, blokzincir onay süresi değildir.",
  "usdEquivalent": "USD karşılığı: ${{usd}}",
  "quoteUnavailable": "Kur alınamadı. Tutarı ve ağı kontrol edin.",
  "depositRequests": "Yatırım talepleri",
  "networkMismatch": "Yalnızca gösterilen ağda gönderin.",
  "safeRecovery": "Bağlantı kesildi. Son kaydedilen talebiniz geri yüklenecek.",
  "historyAll": "Tümü",
  "historyDeposit": "Yatırım",
  "historyWithdrawal": "Çekim",
  "historyEmptyTitle": "İşlem geçmişi yok",
  "historyEmptyDescription": "Yatırımlarınız ve çekim talepleriniz burada görünecek.",
  "historyBankDeposit": "Banka yatırımı",
  "statusPending": "Beklemede",
  "statusReview": "İnceleniyor",
  "statusApproved": "Onaylandı",
  "statusPaid": "Ödendi",
  "statusCompleted": "Tamamlandı",
  "statusRejected": "Reddedildi",
  "statusExpired": "Süresi doldu",
  "statusCancelled": "İptal edildi",
  "statusFailed": "Başarısız",
  "withdrawAcceptedClean": "Çekim talebiniz alındı ve incelemeye gönderildi.",
  "selectBankLocal": "Banka seçin",
  "holderFullNameLocal": "Kart sahibinin tam adı",
  "recipientCardLocal": "Alıcı kart numarası",
  "availableBalanceLocal": "Kullanılabilir bakiye",
  "backWithdrawalLocal": "Geri — çekim yöntemleri",
  "withdrawDetailsLocal": "Çekim bilgilerini girin",
  "paymentMethodsLocal": "Ödeme yöntemleri",
  "paymentAmountLocal": "Ödeme tutarı",
  "transactionTypeLocal": "İşlem türü",
  "walletSectionsLocal": "Cüzdan bölümleri",
  "cryptoTransferTitle": "Kriptopara ödemesi",
  "cryptoTransferAmount": "Gönderilecek tutar",
  "cryptoOrderAmount": "Sipariş tutarı",
  "cryptoTransferAddress": "Yatırım adresi",
  "cryptoTransferNetwork": "Ağ",
  "cryptoShowQr": "QR kodunu aç",
  "cryptoQrWaiting": "QR kodu kullanılamıyor",
  "cryptoNoAddress": "Adres yok. Fon göndermeyin.",
  "cryptoWarnNetwork": "Yalnızca {{network}} ağı üzerinden {{asset}} gönderin. Yanlış ağdan gönderilen fonlar kaybolabilir.",
  "cryptoWarnAmount": "Tutarı ve ağ ücretini dikkatle kontrol edin. Yetersiz transfer yüklenmeyebilir.",
  "cryptoMoreInfo": "Ek ödeme bilgileri",
  "cryptoMemo": "Memo / Tag",
  "prevStep": "Önceki adım",
  "depositAmount": "Yatırım tutarı",
  "paymentInstruction": "Ödeme talimatları",
  "paymentConfirm": "Ödeme onayı",
  "depositStages": "Yatırım adımları",
  "stageAmount": "Tutar",
  "stagePayment": "Ödeme",
  "stageReceipt": "Dekont",
  "receiptSend": "Dekontu gönder",
  "rejected": "Reddedildi",
  "network": "Ağ",
  "paymentNote": "Ödeme notu",
  "extraPaymentInfo": "Ek ödeme bilgileri",
  "invalidAmount": "Geçerli bir tutar girin.",
  "tapToSelect": "Seçmek için dokunun",
  "walletLabel": "Cüzdan",
  "previewBanner": "TEST MODU: Tüm ödeme kartları seçilebilir. Gerçek para göndermeyin; yatırımlar ve çekimler işlenmez.",
  "otherBank": "Diğer banka",
  "cryptoAsset": "Kriptopara",
  "receiveAddress": "Yatırım adresi",
  "notAssigned": "Atanmadı",
  "paymentMethod": "Ödeme yöntemi",
  "bank": "Banka",
  "recipient": "Alıcı",
  "cardNumber": "Kart numarası",
  "qrWhenReady": "QR yalnızca gerçek bir adres mevcutken görünür",
  "qrInactive": "QR pasif",
  "qrInactiveHint": "Yatırım adresi atandığında burada gösterilir.",
  "networkAttention": "Dikkat: {{network}} ağı",
  "networkAttentionBody": "Yalnızca seçilen ağdaki bir adrese gönderin. Yanlış ağ veya tutar fon kaybına yol açabilir.",
  "minDepositFees": "Minimum yatırım ve ücretler",
  "minDepositFeesBody": "Göndermeden önce minimum tutarı ve ağ ücretini kontrol edin. Yatırım adresi olmadan transfer yapmayın.",
  "waitingTransfer": "Transferiniz bekleniyor",
  "waitingTransferBody": "Yalnızca onaylanmış alıcı bilgilerine, gösterilen tutarda ödeme yapın.",
  "wrongTransfer": "Yanlış transferler hakkında",
  "wrongTransferBody": "Yanlış banka, kart veya tutara yapılan ödemeler yüklenmeyebilir.",
  "previewNoAddress": "TEST MODU · ÖDEME ADRESİ YOK · PARA GÖNDERMEYİN",
  "addReceiptTitle": "Ödeme dekontu ekle",
  "addReceiptBody": "Fotoğraf çekin, galeriden seçin veya dosya ekleyin. Test modunda dosya sunucuya yüklenmez.",
  "cameraCapture": "Fotoğraf çek",
  "sampleTimer": "Örnek sayaç — gerçek talep oluşturulmadı",
  "transferDetails": "Transfer bilgileri",
  "paymentDetailsStep": "Ödeme bilgileri",
  "paymentConfirmStep": "Ödeme onayı",
  "iPaidReceipt": "Ödedim · Dekont ekranı",
  "fromGallery": "Galeriden seç",
  "chooseFile": "Dosya seç",
  "cameraFileSelected": "Kamera dosyası seçildi: {{name}}. Test modunda yüklenmedi.",
  "imageSelected": "Görsel seçildi: {{name}}. Test modunda yüklenmedi.",
  "fileSelected": "Dosya seçildi: {{name}}. Test modunda yüklenmedi.",
  "previewTest": "Test",
  "fileNotUploaded": "Dosya sunucuya yüklenmedi",
  "bankSelect": "Banka seçimi",
  "depositBonusSample": "Yatırım bonusu · örnek",
  "checkFinalAmount": "Oluşturulan siparişteki nihai tutarı kontrol edin.",
  "cryptoAwaitingAdmin": "Kripto için dekont yükleme gerekmez. Yönetici blokzincir transferini doğrular ve ancak o zaman bakiyenize yükler.",
  "err_asset_quote_missing": "Bu kripto varlık için kur yok. Daha sonra tekrar deneyin veya başka bir varlık seçin.",
  "err_asset_quote_stale": "Kripto kuru güncel değil. Yenilenmesini bekleyip tekrar deneyin.",
  "err_gram_min_not_met": "Minimum GRAM yatırımı 2 GRAM'dır.",
  "err_amount_out_of_limits": "Tutar izin verilen limitlerin dışında.",
  "err_no_active_requisite": "Bu varlık/ağ için henüz alıcı adresi yapılandırılmadı.",
  "err_unsupported_crypto_pair": "Bu varlık ve ağ çifti desteklenmiyor.",
  "err_receipt_not_required_for_crypto": "Kripto yatırımlarında dekont yükleme gerekmez.",
  "err_asset_feed_unavailable": "Kripto kur kaynağı kullanılamıyor.",
  "orderNumber": "Sipariş numarası:",
  "amountDue": "Ödenecek tutar:",
  "requestProcessing": "Talep işleniyor",
  "paymentCreated": "Ödeme talebi başarıyla oluşturuldu!",
  "completeTransferHint": "Lütfen aşağıdaki ödeme bilgilerini kullanarak transferi tamamlayın.",
  "exactAmountWarn": "Dikkat! Yalnızca gösterilen tutarı doğru ödeme bilgileriyle gönderin.",
  "uploadReceiptAfter": "Transferi tamamladıktan sonra ödeme dekontunu yükleyin.",
  "paymentInfo": "Ödeme bilgileri",
  "cardHolderName": "Kart sahibi adı",
  "receiverName": "Alıcı adı",
  "accountNumber": "Hesap numarası",
  "previewDepositSelected": "TEST MODU: {{method}} — {{amount}} AZN seçildi. Gerçek yatırım oluşturulmadı; para göndermeyin.",
  "previewWithdrawChecked": "TEST MODU: {{method}} için {{amount}} AZN çekim kontrol edildi. Gerçek talep oluşturulmadı.",
  "checkingFileSelection": "Dosya seçiminiz kontrol ediliyor",
  "bonusSampleLine": "%5: {{bonus}} · toplam: {{total}}",
  "phoneNumber": "Telefon numarası",
  "addressLabel": "adres",
  "uploadReceiptReminder": "Ödemeyi tamamladıktan sonra dekontunuzu yüklemeyi unutmayın.",
  "previewWithdrawBanner": "TEST MODU: Gerçek çekimler gönderilmez ve bakiye değişmez.",
  "cardExpiry": "Kart son kullanma (AA/YY)",
  "checkRequest": "Talebi kontrol et",
  "bonusNotOnReal": "Gerçek bakiyeye yüklenmez.",
  "tonConnectTitle": "TON Connect · GRAM",
  "tonConnectWallet": "TON cüzdanını bağla",
  "tonPayConfirm": "Ödemeyi cüzdanda onayla",
  "tonDisconnectWallet": "Cüzdan bağlantısını kes",
  "tonWalletStatus": "Cüzdan durumu",
  "tonWalletNotConnected": "Bağlı değil",
  "tonWalletConnected": "Bağlı · {{address}}",
  "tonWalletConnectedHint": "TON cüzdanınız başarıyla bağlandı.",
  "tonWalletDisconnected": "Cüzdan bağlantısı kesildi.",
  "tonWalletConnectFailed": "Cüzdan bağlantısı başarısız oldu.",
  "tonConnectWalletFirst": "Önce bir TON cüzdanı bağlayın.",
  "tonConfirmInWallet": "Ödemeyi cüzdanınızda onaylayın.",
  "tonPendingAdminReview": "Yatırım talebiniz oluşturuldu. Ödeme yönetici doğrulaması bekliyor.",
  "tonDepositCreated": "TON yatırım talebi oluşturuldu. Ödemeyi cüzdanınızla tamamlayın.",
  "tonPaymentCancelled": "Ödeme iptal edildi veya tamamlanmadı.",
  "tonPaymentMissing": "Ödeme bilgileri eksik. Lütfen tekrar deneyin.",
  "tonPaymentProofMissing": "Cüzdan ödeme kanıtı döndürmedi. Ödeme tamamlanmadıysa tekrar deneyin.",
  "tonWarnNativeOnly": "Yalnızca resmi GRAM jetton gönderin (master EQC47093…). Native TON veya benzer GRAM* tokenları kabul edilmez.",
  "tonWarnAdminReview": "Cüzdan onayı bakiye yüklemesi değildir. Bakiye yalnızca yönetici zincir üstü transferi doğruladıktan sonra artar.",
  "realBalance": "Gerçek bakiye",
  "gameCurrencies": "Oyun para birimleri",
  "walletCta": "Cüzdan",
  "closeGameFirst": "Aktif oyunda açık bahisler var. Önce oyunu kapatın, sonra para birimini değiştirin.",
  "regionLabel": "Ödeme bölgesi",
  "regionCryptoOnly": "Bu bölgede yalnızca kripto ödemeleri kullanılabilir",
  "gameCurrency": "Oyun para birimi",
  "tonWarnGramJettonOnly": "Yalnızca resmi GRAM jetton gönderin (master EQC47093…). Native TON veya benzer GRAM* tokenları kabul edilmez.",
  "tonPayConfirmGram": "GRAM jetton ödemesini cüzdanda onayla",
  "tonJettonMaster": "GRAM jetton sözleşmesi",
  "tonGramWalletMissing": "Bu hesap için GRAM jetton cüzdanı bulunamadı. Önce GRAM ekleyin veya adres/QR transferi kullanın.",
  "tonGramConnectUnavailable": "TON Connect GRAM transferi geçici olarak kullanılamıyor. Adres ve QR yatırımı çalışmaya devam eder.",
  "cryptoDepositTitle": "Kriptopara ödemesi",
  "cryptoMinDepositLabel": "Minimum tutar",
  "cryptoWarnNetworkGeneric": "Yalnızca gösterilen {{asset}} tokenını ve {{network}} ağını kullanın. Yanlış ağdan gönderilen fonlar kaybolabilir.",
  "cryptoWarnGramNetwork": "Yalnızca TON ağındaki gösterilen GRAM tokenını kullanın. Yanlış ağdan gönderilen fonlar kaybolabilir.",
  "cryptoWarnMinGeneric": "Minimum yatırımın ({{amount}}) altındaki tutarlar bakiyenize yüklenmeyebilir.",
  "cryptoTxHashLabel": "Blokzincir TX hash",
  "cryptoTxHashPlaceholder": "İşlem hash'ini girin",
  "cryptoSubmitTx": "TX hash gönder",
  "cryptoTxSubmitted": "TX alındı. Bakiye yönetici doğrulamasından sonra artar.",
  "cryptoTxHashInvalid": "TX hash çok kısa.",
  "cryptoOpenFirst": "Önce yatırım panelini açın.",
  "tonConnectAmountHint": "TON Connect ile GRAM göndermek için bir AZN tutarı girin (en az 2 GRAM karşılar).",
  "tonConnectStartPay": "TON Connect ile öde",
  "cryptoBack": "Geri",
  "cryptoReportPayment": "Ödemeyi bildir",
  "cryptoTonConnectOption": "TON Connect ile öde",
  "cryptoQrSaved": "QR kodu kaydedildi",
  "cryptoConfirmPayment": "Ödemeyi onayla",
  "cryptoConfirmSend": "Gönder",
  "cryptoConfirmAccepted": "Talebiniz inceleniyor.",
  "cryptoReportedAmountLabel": "Gönderdiğiniz tutar ({{asset}})",
  "cryptoReportedAmountPlaceholder": "örn. 10",
  "cryptoReportedAmountInvalid": "Geçerli bir kripto tutarı girin.",
  "cryptoBelowMinimum": "Minimum yatırım: {{amount}}"
}
